// extracted by mini-css-extract-plugin
module.exports = {"CurvyUnderline":"Description_CurvyUnderline__RP2cA","ImageContainer":"Description_ImageContainer__2pVOK"};